import React from 'react'
import PropTypes from 'prop-types'
// import moment from 'moment'
import R from 'ramda'
import {
  Message,
  Form,
  Button
} from 'semantic-ui-react'

import {sendDelete} from './sendRequest'

import {
  AUTH_API_URL
} from '_constants'

import BaseInputField from '_forms/baseInput'

class DeactivateForm extends React.PureComponent {
  state = {
    isLoading: false,
    reason: ''
  }

  onChange = (e, data) => this.setState({[data.name]: data.value})

  onDeactivate = () => {
    const invoice = R.path(['props', 'invoice'], this)
    if (!(invoice && R.has('line_item_id', invoice))) {
      return window.alert('No invoice selected or no line item available')
    }
    const url = `${AUTH_API_URL}/xero_invoice_items/${invoice.line_item_id}`
    this.setState({isLoading: true})
    sendDelete(url, {reason: this.state.reason}, (errMsg) => {
      if (errMsg) {
        this.setState({isLoading: false})
        return window.alert(errMsg)
      }
      // don't filter any responses
      this.setState({isLoading: false})
      this.props.onDeactivate(invoice)
    })
  }

  render () {
    return (
      <Form size='tiny'>
        <Message
          info
          header=''
          content='Deactivating the invoice will set the invoice to void for purposes of counting licenses in the auth server.  It will NOT change anything in Xero.'
        />
        <Form.Group>
          <BaseInputField
            width={16}
            value={this.state.reason}
            onChange={this.onChange}
            name='reason'
            labelTxt='Why?'
            popupTxt='Please provide a short description/reason for why this invoice line item is to be deactivated'
          />
        </Form.Group>
        <Form.Group>
          <Form.Field width={16}>
            <Button.Group>
              <Button onClick={this.props.onCancel}>Cancel</Button>
              <Button.Or />
              <Button
                positive
                loading={this.state.isLoading}
                disabled={this.state.reason.trim() === ''}
                onClick={this.onDeactivate}
              >Deactivate</Button>
            </Button.Group>
          </Form.Field>
        </Form.Group>
      </Form>
    )
  }
}

DeactivateForm.propTypes = {
  invoice: PropTypes.object.isRequired,
  onCancel: PropTypes.func.isRequired,
  onDeactivate: PropTypes.func.isRequired
}

export default DeactivateForm



// WEBPACK FOOTER //
// ./webAdmin/views/xero/deactivate.js